import motion from "@/lib/lazy-motion-tags";
import { Card } from "@/components/ui/card";
import ResponsiveImage from "@/components/ResponsiveImage";
import { Home, ShowerHead, Sparkles, Hammer, Box } from "lucide-react";

const ProductsSection = () => {
  const products = [
    {
      icon: Home,
      image: 'Classic-interior-doors.jpg',
      title: "أبواب داخلية كلاسيك",
      description: "الخيار الأمثل للغرف والممرات",
    },
    {
      icon: ShowerHead,
      image: 'Bathroom-Doors.png',
      title: "أبواب الحمامات",
      description: "مصممة خصيصاً لتحدي الماء والرطوبة",
    },
    {
      icon: Sparkles,
      image: 'doors.png',
      title: "أبواب ديكورية فاخرة",
      description: "عندما يلتقي الفن بالوظيفة",
    },
    {
      icon: Box,
      image: 'Earless_doors.png',
      title: "أبواب بدون حلق",
      description: "التصميم العصري بأبسط أشكاله",
    },
    {
      icon: Hammer,
      image: 'cnc.png',
      title: "أبواب CNC محفورة",
      description: "تكنولوجيا CNC لتفاصيل لا مثيل لها",
    },
  ];

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-6">
            <span className="text-gradient">منتجاتنا</span>
          </h2>
          <p className="text-xl text-muted-foreground">
            مجموعة أبواب WPC المتنوعة - الحل المثالي لكل مساحة
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
            {products.map((product, index) => {
            const Icon = product.icon;
            const imgUrl = new URL(`../../assets/${product.image}`, import.meta.url).href;

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                    <Card className="p-0 bg-gradient-to-br from-muted/50 to-card hover-lift h-full overflow-hidden group cursor-pointer">
                  <div className="aspect-square relative overflow-hidden">
                    {
                      (() => {
                        const imgJpg = new URL(`../../assets/${product.image}`, import.meta.url).href;
                        const imgWebp = new URL(`../../assets/${product.image}.webp`, import.meta.url).href;
                        const imgAvif = new URL(`../../assets/${product.image}.avif`, import.meta.url).href;
                        return (
                          <ResponsiveImage
                            fill
                            src={imgJpg}
                            webp={imgWebp}
                            avif={imgAvif}
                            alt={product.title}
                            className="group-hover:scale-105 transition-transform duration-300"
                          />
                        );
                      })()
                    }
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                    <div className="absolute top-4 left-4 w-12 h-12 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-lg">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-bold mb-2 line-clamp-2">{product.title}</h3>
                    <p className="text-sm text-muted-foreground line-clamp-2">{product.description}</p>
                  </div>
                </Card>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a
            href="/products"
            className="inline-flex items-center px-8 py-3 bg-gradient-primary text-white font-semibold rounded-full hover:shadow-lg transition-all duration-300 hover:scale-105"
          >
            عرض جميع المنتجات
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductsSection;
